import {createCommand, LexicalCommand} from 'lexical';
import {ImagePayload} from '../../nodes/Images/ImageNode/ImageNode';

export type InsertImagePayload = Readonly<ImagePayload>;

export const INSERT_IMAGE_COMMAND: LexicalCommand<InsertImagePayload> =
    createCommand('INSERT_IMAGE_COMMAND');
